export default __webpack_public_path__ + "static/DSC_0397-98ea417b8f77c85214d91348f4a76221.jpg";